import { QuantityUnit } from 'src/shared/types'
import type { MapperConfig } from '../mapperConfigs'

import { DocumentIcon } from '@heroicons/react/24/outline'

// export const creo: MapperConfig = {
//   orgIds: ['charbroil-sandbox', 'charbroil'],
//   name: 'Creo',
//   type: 'Upload',
//   Logo: DocumentIcon,
//   rootIsTopLevel: true,
//   fileToRows: {
//     parsers: [{
//       fileType: 'txt',
//       parserId: 'creo'
//     }, {
//       fileType: 'bom',
//       parserId: 'creo'
//     }, {
//       fileType: 'json',
//       parserId: 'creo'
//     }]
//   },
//   importOutputFields: {
//     metadata: [
//       'material',
//       'finish',
//       'artwork-number',
//       'sheet-metal-thickness',
//       'factory-drawing-number',
//       'factory-part-number',
//       'alt-language-description',
//     ]
//   },
//   // rowsToBom: [{
//   //   type: 'FilterRemove',
//   //   config: {
//   //     conditions: [{
//   //       type: 'contains',
//   //       column: 'part_number',
//   //       value: 'G702'
//   //     }, {
//   //       type: 'contains',
//   //       column: 'part_number',
//   //       value: 'G329'
//   //     }]
//   //   }
//   // }],
//   standardizeBom: {
//     columns: {
//       summary: {
//         type: 'ignore'
//       },
//       metadata: {
//         material: {
//           type: 'simple',
//           value: '{{row.material}}'
//         },
//         finish: {
//           type: 'simple',
//           value: '{{row.finish}}'
//         },
//         'artwork-number': {
//           type: 'simple',
//           value: '{{row.art_number}}'
//         },
//         'sheet-metal-thickness': {
//           type: 'simple',
//           value: '{{row.smt_thickness}}'
//         },
//         'factory-drawing-number': {
//           type: 'simple',
//           value: '{{row.factory_drawing_number}}'
//         },
//         'factory-part-number': {
//           type: 'simple',
//           value: '{{row.factory_part_number}}'
//         },
//         'alt-language-description': {
//           type: 'simple',
//           value: '{{row.alternate_desc}}'
//         }
//       },
//       hierarchy: {
//         value: '{{row.hierarchy}}',
//         type: 'simple'
//       },
//       partNumber: {
//         value: '{{row.name}}',
//         type: 'simple'
//       },
//       cadRev: {
//         type: 'empty'
//       },
//       categoryId: {
//         type: 'simple',
//         value: 'mechanical-part'
//       },
//       isOffTheShelf: {
//         value: 'false',
//         type: 'simple'
//       },
//       name: {
//         value: '{{row.description}}',
//         type: 'simple'
//       },
//       quantity: {
//         value: '{{row.quantity}}',
//         type: 'simple',
//       },
//       units: {
//         value: 'each' as QuantityUnit,
//         type: 'quantity'
//       },
//     }
//   }
// }

export const mideaLoose: MapperConfig = {
  name: 'Midea Spreadsheet',
  type: 'Upload',
  Logo: DocumentIcon,
  orgIds: ['charbroil-sandbox', 'charbroil'],
  noProject: true,
  rootIsTopLevel: false,
  importOutputFields: {
    metadata: ['material', 'finish', 'sheet-metal-thickness', 'factory-part-number', 'factory-drawing-number', 'alt-language-description']
  },
  fileToRows: {
    xlsx: {
      enable: true,
      firstRow: 1  // Skip header row
    }
  },
  rowsToBom: [{
    type: 'FilterKeep',
    config: {
      conditions: [{
        type: 'regex',
        column: 'md_part_no',
        value: '^\\d{14}$',
      }]
    }
  }, {
    type: 'MergeDuplicateChildren',
    config: {
      duplicateCheck: {
        type: 'simple',
        value: '${row.md_part_no}'
      },
      hierarchy: {
        type: 'simple',
        value: '${row.hierarchy}'
      },
      quantity: {
        type: 'simple',
        value: '${row.quantity}'
      },
    }
  }],
  standardizeBom: {
    columns: {
      // Map metadata fields
      metadata: {
        'material': {
          type: 'simple',
          value: '${row.material || ""}'
        },
        'finish': {
          type: 'simple',
          value: '${row.finish || ""}'
        },
        'sheet-metal-thickness': {
          type: 'simple',
          value: '${row.gage || ""}'
        },
        'factory-part-number': {
          type: 'simple',
          value: '${row["md_part_no"] || ""}'
        },
        'factory-drawing-number': {
          type: 'simple',
          value: '${row["md_drawing_no"] || ""}'
        },
        'alt-language-description': {
          type: 'simple',
          value: '${row["ch_desc"] || ""}'
        },
      },
      // Map standard fields
      hierarchy: [{
        conditions: [{
          type: 'empty',
          column: 'hierarchy'
        }, {
          type: 'eq',
          column: 'hierarchy',
          value: '0'
        }],
        onMatch: {
          type: 'simple',
          value: '1'
        }
      }, {
        default: true,
        onMatch: {
          type: 'simple',
          value: '1.${row.hierarchy}'
        }
      }],
      partNumber: [{
        onMatch: {
          type: 'simple',
          value: 'MID-${row.md_part_no}'
        },
        conditions: [{
          type: 'contains',
          column: 'cb_part_no',
          value: 'n/a'
        }, {
          type: 'eq',
          column: 'cb_part_no',
          value: 'na'
        }, {
          type: 'empty',
          column: 'cb_part_no',
        }]
      }, {
        default: true,
        onMatch: {
          type: 'simple',
          value: '${row.cb_part_no}'
        }
      }],
      name: {
        type: 'simple',
        value: '${row.eng_desc}'
      },
      summary: [{
        default: true,
        onMatch: {
          type: 'empty'
        }
      }],
      quantity: {
        type: 'simple',
        value: '${row.__quantity || row.quantity}'
      },
      units: {
        type: 'quantity',
        value: 'each' as QuantityUnit
      },
      categoryId: [{
        conditions: [{
          type: 'eq',
          column: 'material',
          value: 'ASSY'
        }],
        onMatch: {
          type: 'simple',
          value: 'mechanical-part'
        }
      }, {
        conditions: [{
          type: 'eq',
          column: 'material',
          value: 'SPCC'
        }],
        onMatch: {
          type: 'simple',
          value: 'mechanical-part'
        }
      }, {
        conditions: [{
          type: 'startsWith',
          column: 'material',
          value: 'SUS'
        }],
        onMatch: {
          type: 'simple',
          value: 'mechanical-part'
        }
      }, {
        default: true,
        onMatch: {
          type: 'simple',
          value: 'mechanical-part'
        }
      }],
      isOffTheShelf: {
        type: 'simple',
        value: 'false'
      }
    }
  }
}

